/* eslint no-unused-vars: 0 */
import {
  objectTransform,
  storedProcParameters,
  makeResourceFirst,
  handleError,
} from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import dayjs from "dayjs";
import * as queries from "../graphql/queries.js";
import * as mutations from "../graphql/mutations.js";
import getOffsetTime from "../utils/getOffsetTime.js";
import demoParams from "../__test__/demoParams.js";
const { demoMode, demoPreviousPostingsResourceId } = demoParams;
import { getTour } from "../api/tourApi.js";

const client = generateClient();

/**
 * Returns an array of posted schedules that the user can view by calling the api.
 * @param {*} resourceId
 */
export async function getListPostedSchedules(resourceId) {
  const { companyId } = storedProcParameters;
  let listPostedSchedules = await client.graphql(
    {
      query: queries.scheduleApIgetPostedSchedulesList, 
      variables: {
        resourceId,
        companyId,
      }
    }
  );
  return listPostedSchedules.data.scheduleAPIgetPostedSchedulesList;
}

/**
 * Returns the posted schedule selected by the user from the api.
 * @param {*} startDate
 * @param {*} scheduleFormat
 *  @param {*} postedId
 * @param {*g} resourceId
 * @param {*} resourceName
 */
export async function getPostedSchedules(
  startDate,
  scheduleFormat,
  postedId,
  resourceId,
  resourceName
) {
  let regex = /^\d{4}-\d{2}-\d{2}$/;
  var coincidences = regex.exec(startDate||'') || [];
  if(coincidences.length == 1){
    startDate= `${startDate.substring(5,7)}\\${startDate.substring(8,10)}\\${startDate.substring(0,4)}`;
  }
  let response;
  let postedSchedules;
  const variables = {
    startDate, // => input variable is ignored, storedProc returns more accurate startDate (see line 47 below)
    scheduleFormat,
    postedId: postedId,
  };
  if (scheduleFormat === 1 || scheduleFormat === 2) {
    response = await client.graphql(
      {
        query: queries.scheduleApIgetPostedSchedules, 
        variables: variables
      }
    );
    postedSchedules =
      response.data.scheduleAPIgetPostedSchedules.postedSchedule;
  } else {
    // scheduleFormat === 7 || scheduleFormat === 9
    response = await client.graphql(
      {
        query: queries.scheduleApIgetPostedSchedules, 
        variables: variables
      }
    );
    postedSchedules =
      response.data.scheduleAPIgetPostedSchedules.postedSchedule;
  }

  startDate = response.data.scheduleAPIgetPostedSchedules.startDate.replace("Z",'')

  let userName = response.data.scheduleAPIgetPostedSchedules.userName || "";
  let savedDate = response.data.scheduleAPIgetPostedSchedules.savedDate
    ? response.data.scheduleAPIgetPostedSchedules.savedDate.replace("Z","")
    : "";
  let resourceCollectionId =
    response.data.scheduleAPIgetPostedSchedules.resourceCollectionId || null;

  let sortedPostedScheduleArray;
  if (postedSchedules) {
    // transform dayType and assignment arrays into objects for ease of use in generate-items.js
    let postedScheduleArray = objectTransform(postedSchedules);

    // bring resource (user or selectedResource) to the front of the array
    sortedPostedScheduleArray = makeResourceFirst(
      postedScheduleArray,
      resourceId
    );
  } else {
    alert("Theere was a problem parsing the posted schedule.");
  }

  const postedSchedule = {
    resourceId,
    startDate,
    scheduleFormat,
    resourceName,
    userName,
    savedDate,
    resourceCollectionId,
    postedSchedule: sortedPostedScheduleArray,
  };
  const JSONData = response.data.scheduleAPIgetPostedSchedules.JSONData.map(data => {
    data.startDate = response.data.scheduleAPIgetPostedSchedules.startDate
    return data
  })
  return [postedSchedule, JSONData];
}

/**
 * Returns an array of previous posted schedules that the user can view by calling the api.
 * @param {*} resourceId
 */
export async function getListPreviousPostings(resourceId) {
  const { companyId } = storedProcParameters;
  let listPreviousPostingsSchedules = await client.graphql(
    {
      query: queries.scheduleApIgetPreviousPostings, 
      variables: {
        resourceId: demoMode ? demoPreviousPostingsResourceId : resourceId,
        companyId,
      }
    }
  );
  return listPreviousPostingsSchedules.data.scheduleAPIgetPreviousPostings;
}

export async function getResourceCollectionInformation(parameters) {
  let resourceCollectionInformation = await client.graphql(
    {
      query: queries.scheduleApIgetResourceCollectionInformation,
      variables: parameters
    }
  )
    .then((data) => {
      let info =
        data.data.scheduleAPIgetResourceCollectionInformation.data[0] || {};
      return info;
    })
    .catch((error) => {
      console.log(error);
    });
  return resourceCollectionInformation;
}

export async function createPostedSchedule(parameters) {
  parameters.ipAddress = "27.0.0.1";
  let response = await client.graphql(
    {
      query: mutations.scheduleApIcreatePostedSchedule, 
      variables: parameters
    }
  )
    .then((data) => {
      return data.data.scheduleAPIcreatePostedSchedule;
    })
    .catch((error) => {
      let errorMessage;
      for (let x = 0; x < error.errors.length; x++) {
        if (x === 0) {
          errorMessage = error.errors[x].message;
        } else {
          errorMessage += "/" + error.errors[x].message;
        }
      }
      throw Error(errorMessage);
    });
  return response;
}

const addOffsetToDate = (date) => {
  let dateOffset = getOffsetTime(dayjs(date));
  let offsetDate = dayjs(date)
    .add(dateOffset, "minute")
    .format();

  return offsetDate;
};
